import { Avatar } from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import React from "react";
import { S3baseUrl } from "../../../../../bl_libs/ApiCalling";

function UserCard(props) {
  const { requestData, type } = props;

  const {
    company_profile,
    customer_profile,
    customer_User,
    foreman_profile,
    foreman_User,
    customer_rating,
    company_rating,
    company_User,
  } = requestData;

  if (type === "customer") {
    const { profile_picture, first_name, last_name } = customer_profile;
    const { email, phone } = customer_User;
    return (
      <>
        <div className="form-group text-center pt-4">
          {
            //if preview is empty show default
            profile_picture ? (
              //if profile picture is available show profile
              <img
                src={S3baseUrl + profile_picture}
                className="circle-box rounded-circle edit-profile-img"
              />
            ) : (
              //else show default picture
              <Avatar
                style={{
                  width: 150,
                  height: 150,
                  fontSize: 22,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              ></Avatar>
            )
          }
          <div className="pt-3">
            <Rating
              value={customer_rating ? customer_rating : 0}
              readOnly
              precision={0.1}
            />
          </div>
        </div>
        <div className="row small-font-size pl-4 pt-2">
          <div className="col-5 text-left dark-grey-color">Name:</div>
          <div className="col-7 text-left black-color">
            {first_name + " " + last_name}
          </div>
        </div>
        <div className="row small-font-size pl-4 pt-2">
          <div className="col-5 text-left dark-grey-color">Email:</div>
          <div className="col-7 text-left black-color">{email}</div>
        </div>
        <div className="row small-font-size pl-4 pt-2 pb-4">
          <div className="col-5 text-left dark-grey-color">Phone:</div>
          <div className="col-7 text-left black-color">{phone}</div>
        </div>
      </>
    );
  }

  if (type === "company") {
    //
    // if Company not assign
    //
    if (!company_profile) {
      return (
        <>
          <div className="p-4 text-center">Company not assigned yet.</div>
        </>
      );
    }

    const { profile_picture, name } = company_profile;
    const { email, phone } = company_User;

    return (
      <>
        <div className="form-group text-center pt-4">
          {
            //if preview is empty show default
            profile_picture ? (
              //if profile picture is available show profile
              <img
                src={S3baseUrl + profile_picture}
                className="circle-box rounded-circle edit-profile-img"
              />
            ) : (
              //else show default picture
              <Avatar
                style={{
                  width: 150,
                  height: 150,
                  fontSize: 22,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              ></Avatar>
            )
          }
          <div className="pt-3">
            <Rating
              value={company_rating ? company_rating : 0}
              readOnly
              precision={0.1}
            />
          </div>
        </div>
        <div className="row small-font-size pl-4 pt-2">
          <div className="col-5 text-left dark-grey-color">Name:</div>
          <div className="col-7 text-left black-color">{name}</div>
        </div>
        <div className="row small-font-size pl-4 pt-2">
          <div className="col-5 text-left dark-grey-color">Email:</div>
          <div className="col-7 text-left black-color">{email}</div>
        </div>
        <div className="row small-font-size pl-4 pt-2 pb-4">
          <div className="col-5 text-left dark-grey-color">Phone:</div>
          <div className="col-7 text-left black-color">{phone}</div>
        </div>
      </>
    );
  }

  if (type === "foreman") {
    //
    // if foreman not assign
    //
    if (!foreman_profile) {
      return (
        <>
          <div className="p-4 text-center">Foreman not assigned yet.</div>
        </>
      );
    }
    const { profile_pic, first_name, last_name } = foreman_profile;
    const { email, phone } = foreman_User;

    return (
      <>
        <div className="form-group text-center pt-4">
          {
            //if preview is empty show default
            profile_pic ? (
              //if profile picture is available show profile
              <img
                src={S3baseUrl + profile_pic}
                className="circle-box rounded-circle edit-profile-img"
              />
            ) : (
              //else show default picture
              <Avatar
                style={{
                  width: 150,
                  height: 150,
                  fontSize: 22,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              ></Avatar>
            )
          }
        </div>
        <div className="row small-font-size pl-4 pt-2">
          <div className="col-5 text-left dark-grey-color">Name:</div>
          <div className="col-7 text-left black-color">
            {first_name + " " + last_name}
          </div>
        </div>
        <div className="row small-font-size pl-4 pt-2">
          <div className="col-5 text-left dark-grey-color">Email:</div>
          <div className="col-7 text-left black-color">{email}</div>
        </div>
        <div className="row small-font-size pl-4 pt-2 pb-4">
          <div className="col-5 text-left dark-grey-color">Phone:</div>
          <div className="col-7 text-left black-color">{phone}</div>
        </div>
      </>
    );
  }

  return <>Invalid type</>;
}

export default UserCard;
